import { useEffect } from 'react';
import { useFamilyContext } from '../contexts/FamilyContext';
import MilestoneCompletionTriggers from '../services/MilestoneCompletionTriggers.jsx';

export function useMilestoneCompletionTriggers() {
  const { currentUser } = useFamilyContext();
  
  useEffect(() => {
    if (currentUser?.id) {
      // Initialize completion detection triggers
      MilestoneCompletionTriggers.initialize(currentUser.id);
      
      // Check all milestones on initial load
      setTimeout(() => {
        MilestoneCompletionTriggers.checkAllMilestonesForUser(currentUser.id);
      }, 2000);
      
      return () => {
        // Cleanup subscriptions on unmount
        MilestoneCompletionTriggers.cleanup();
      };
    }
  }, [currentUser?.id]);
  
  return {
    checkNow: () => {
      if (currentUser?.id) {
        MilestoneCompletionTriggers.checkAllMilestonesForUser(currentUser.id);
      }
    }
  };
}